/**
 * Returns a function that computes the count over an array of items
 */
export function n() {
  return (items: any[]) => items.length;
}
